import React, { useEffect, useState } from 'react'
import { LinkContainer } from 'react-router-bootstrap'

import Stack from 'react-bootstrap/Stack'
import Nav from 'react-bootstrap/Nav'

import AuthService from '../../../utilities/services/auth.service'

export default function SettingsMenu() {
  const [, setRefreshKey] = useState(0)

  useEffect(() => {
    const handler = () => setRefreshKey((key) => key + 1)
    window.addEventListener('blocktickets:org-settings-updated', handler)
    return () =>
      window.removeEventListener('blocktickets:org-settings-updated', handler)
  }, [])

  const organization = AuthService.getOrg()?.[0]
  const isSuperUser = AuthService.isSuperAdminOrganizer()
  const donationsEnabled = Boolean(organization?.setting?.donationsEnabled)
  const foodAndBeverageEnabled = Boolean(organization?.setting?.foodAndBeverage)
  return (
    <Stack as="ul" gap={2} id="settings-menu" className="mb-3">
      <Nav.Item as="li">
        <LinkContainer to="organization-information">
          <Nav.Link>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 12H14V20H19C19.5523 20 20 19.5523 20 19V13C20 12.4477 19.5523 12 19 12ZM12 10V22H19C20.6569 22 22 20.6569 22 19V13C22 11.3431 20.6569 10 19 10H12Z"
                fill="#777E91"
              />
              <path
                d="M18 15C18 14.4477 17.5523 14 17 14C16.4477 14 16 14.4477 16 15C16 15.5523 16.4477 16 17 16C17.5523 16 18 15.5523 18 15Z"
                fill="#777E91"
              />
              <path
                d="M18 18C18 17.4477 17.5523 17 17 17C16.4477 17 16 17.4477 16 18C16 18.5523 16.4477 19 17 19C17.5523 19 18 18.5523 18 18Z"
                fill="#777E91"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 22C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H11C12.6569 2 14 3.34315 14 5V22H5ZM5 4H11C11.5523 4 12 4.44772 12 5V20H10V19C10 18.4477 9.55229 18 9 18H7C6.44772 18 6 18.4477 6 19V20H5C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44771 4 5 4Z"
                fill="#777E91"
              />
              <path
                d="M9 6C9.55229 6 10 6.44772 10 7C10 7.55228 9.55228 8 9 8H7C6.44772 8 6 7.55228 6 7C6 6.44772 6.44772 6 7 6H9Z"
                fill="#777E91"
              />
              <path
                d="M9 10C9.55229 10 10 10.4477 10 11C10 11.5523 9.55228 12 9 12H7C6.44772 12 6 11.5523 6 11C6 10.4477 6.44772 10 7 10H9Z"
                fill="#777E91"
              />
              <path
                d="M10 15C10 14.4477 9.55229 14 9 14H7C6.44772 14 6 14.4477 6 15C6 15.5523 6.44772 16 7 16H9C9.55228 16 10 15.5523 10 15Z"
                fill="#777E91"
              />
            </svg>
            Organization info
          </Nav.Link>
        </LinkContainer>
      </Nav.Item>
      {isSuperUser && (
        <Nav.Item as="li">
          <LinkContainer to="organization-settings">
            <Nav.Link>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12Z"
                  fill="#777E91"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                  fill="#777E91"
                />
                <path
                  d="M12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5V5.69036C10.0827 5.83058 9.00842 6.36835 8.1967 7.1967C7.36835 8.00842 6.83058 9.0827 6.69036 10.25H6C5.58579 10.25 5.25 10.5858 5.25 11C5.25 11.4142 5.58579 11.75 6 11.75H6.69036C6.83058 12.9173 7.36835 13.9916 8.1967 14.8033C9.00842 15.6317 10.0827 16.1694 11.25 16.3096V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V16.3096C13.9173 16.1694 14.9916 15.6317 15.8033 14.8033C16.6317 13.9916 17.1694 12.9173 17.3096 11.75H18C18.4142 11.75 18.75 11.4142 18.75 11C18.75 10.5858 18.4142 10.25 18 10.25H17.3096C17.1694 9.0827 16.6317 8.00842 15.8033 7.1967C14.9916 6.36835 13.9173 5.83058 12.75 5.69036V5Z"
                  fill="#777E91"
                />
              </svg>
              Organization settings
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
      )}
      <Nav.Item as="li">
        <LinkContainer to="email-templates">
          <Nav.Link>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4ZM4 6V18H20V8.236L12.553 13.789C12.217 14.022 11.783 14.022 11.447 13.789L4 8.236V6Z"
                fill="#777E91"
              />
            </svg>
            Email templates
          </Nav.Link>
        </LinkContainer>
      </Nav.Item>
      <Nav.Item as="li">
        <LinkContainer to="marketing-attribution">
          <Nav.Link>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                fill="#777E91"
              />
              <path
                d="M11 7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V11.382L15.4472 12.6056C15.9413 12.8526 16.1416 13.4533 15.8945 13.9474C15.6475 14.4415 15.0469 14.6418 14.5528 14.3948L11.5528 12.8948C11.214 12.7254 11 12.3791 11 12V7Z"
                fill="#777E91"
              />
            </svg>
            Marketing Attribution
          </Nav.Link>
        </LinkContainer>
      </Nav.Item>
      <Nav.Item as="li">
        <LinkContainer to="team-management">
          <Nav.Link>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.4998 10.9692C16.4731 10.7233 18.0001 9.04002 18.0001 7.0001C18.0001 4.96018 16.4731 3.27692 14.4998 3.03101C15.4335 4.08875 16.0001 5.47826 16.0001 7.0001C16.0001 8.52194 15.4335 9.91145 14.4998 10.9692Z"
                fill="#777E91"
              />
              <path
                d="M20 20.0001C20 20.5524 20.4477 21.0001 21 21.0001C21.5523 21.0001 22 20.5524 22 20.0001V18.0001C22 15.34 19.9227 13.1651 17.3018 13.009C18.3539 13.9408 19.1587 15.1454 19.6055 16.5121C19.8565 16.9506 20 17.4586 20 18.0001V20.0001Z"
                fill="#777E91"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 15C5.34315 15 4 16.3431 4 18V20C4 20.5523 3.55228 21 3 21C2.44772 21 2 20.5523 2 20V18C2 15.2386 4.23858 13 7 13H13C15.7614 13 18 15.2386 18 18V20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20V18C16 16.3431 14.6569 15 13 15H7Z"
                fill="#777E91"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 5C8.89543 5 8 5.89543 8 7C8 8.10457 8.89543 9 10 9C11.1046 9 12 8.10457 12 7C12 5.89543 11.1046 5 10 5ZM6 7C6 4.79086 7.79086 3 10 3C12.2091 3 14 4.79086 14 7C14 9.20914 12.2091 11 10 11C7.79086 11 6 9.20914 6 7Z"
                fill="#777E91"
              />
            </svg>
            Team management
          </Nav.Link>
        </LinkContainer>
      </Nav.Item>
      <Nav.Item as="li">
        <LinkContainer to="security">
          <Nav.Link>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.6838 3.71367L5.68377 5.71367C5.27543 5.84978 5 6.23192 5 6.66235V12.0001C5 14.0258 6.01463 15.7554 7.48432 17.2097C8.95718 18.6672 10.7303 19.6841 11.8268 20.2266C11.9405 20.2829 12.0595 20.2829 12.1731 20.2266C13.2697 19.6841 15.0428 18.6672 16.5157 17.2097C17.9854 15.7554 19 14.0258 19 12.0001V6.66235C19 6.23192 18.7246 5.84978 18.3162 5.71367L12.3162 3.71367C12.111 3.64525 11.889 3.64525 11.6838 3.71367ZM5.05132 3.8163C3.82629 4.22465 3 5.37106 3 6.66235V12.0001C3 17.5021 8.56019 20.8418 10.9399 22.0192C11.6125 22.352 12.3875 22.352 13.0601 22.0192C15.4398 20.8418 21 17.5021 21 12.0001V6.66235C21 5.37106 20.1737 4.22465 18.9487 3.8163L12.9487 1.8163C12.3329 1.61104 11.6671 1.61104 11.0513 1.8163L5.05132 3.8163Z"
                fill="#777E91"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L12.2728 14.1414C11.5698 14.8444 10.4302 14.8444 9.72721 14.1414L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929C8.68342 10.9024 9.31658 10.9024 9.70711 11.2929L11 12.5858L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289Z"
                fill="#777E91"
              />
            </svg>
            Security
          </Nav.Link>
        </LinkContainer>
      </Nav.Item>
      {/* <Nav.Item as="li">
        <LinkContainer to="payouts">
          <Nav.Link>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                fill="#777E91"
              />
              <path
                d="M11 7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7C14.6569 7 16 8.34315 16 10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10.7434C10.3328 9 10 9.33284 10 9.74342C10 10.0634 10.2048 10.3475 10.5083 10.4487L14.1241 11.6539C15.2444 12.0274 16 13.0757 16 14.2566C16 15.7717 14.7717 17 13.2566 17H13C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C9.34315 17 8 15.6569 8 14C8 13.4477 8.44771 13 9 13C9.55229 13 10 13.4477 10 14C10 14.5523 10.4477 15 11 15H13.2566C13.6672 15 14 14.6672 14 14.2566C14 13.9366 13.7952 13.6525 13.4917 13.5513L9.87587 12.3461C8.75562 11.9726 8 10.9243 8 9.74342C8 8.22827 9.22827 7 10.7434 7H11Z"
                fill="#777E91"
              />
            </svg>
            Payouts
          </Nav.Link>
        </LinkContainer>
      </Nav.Item> */}
      <Nav.Item as="li">
        <LinkContainer to="terminals">
          <Nav.Link>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7ZM5 6H19C19.5523 6 20 6.44771 20 7V8H4V7C4 6.44772 4.44772 6 5 6ZM4 10V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V10H4Z"
                fill="#777E91"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 15C6 14.4477 6.44772 14 7 14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H7C6.44772 16 6 15.5523 6 15Z"
                fill="#777E91"
              />
            </svg>
            Terminals
          </Nav.Link>
        </LinkContainer>
      </Nav.Item>
      <Nav.Item as="li">
        <LinkContainer to="scanners">
          <Nav.Link>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 4H16C17.1046 4 18 4.89543 18 6V8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H8C6.89543 22 6 21.1046 6 20V18H4C2.89543 18 2 17.1046 2 16V6C2 4.89543 2.89543 4 4 4ZM8 6V20H20V10H16C14.8954 10 14 9.10457 14 8V6H8ZM6 8H12V16H6V8Z"
                fill="#777E91"
              />
              <path d="M10 11H12V13H10V11Z" fill="#777E91" />
            </svg>
            Scanners
          </Nav.Link>
        </LinkContainer>
      </Nav.Item>
      <Nav.Item as="li">
        <LinkContainer to="custom-fees">
          <Nav.Link>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zM7 15h4v-2H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5z"
                fill="#777E91"
              />
              <path d="M8 11h8v2H8v-2z" fill="#777E91" />
            </svg>
            Custom fees
          </Nav.Link>
        </LinkContainer>
      </Nav.Item>
      <Nav.Item as="li">
        <LinkContainer to="buyer-types">
          <Nav.Link>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12ZM12 14C8.13401 14 5 16.134 5 20V21C5 21.5523 5.44772 22 6 22H18C18.5523 22 19 21.5523 19 21V20C19 16.134 15.866 14 12 14Z"
                fill="#777E91"
              />
            </svg>
            Buyer types
          </Nav.Link>
        </LinkContainer>
      </Nav.Item>
      {foodAndBeverageEnabled && (
        <Nav.Item as="li">
          <LinkContainer to="marketplace">
            <Nav.Link>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3 4C2.44772 4 2 4.44772 2 5V19C2 19.5523 2.44772 20 3 20H9V22H3C1.34315 22 0 20.6569 0 19V5C0 3.34315 1.34315 2 3 2H21C22.6569 2 24 3.34315 24 5V9H22V5C22 4.44772 21.5523 4 21 4H3ZM14 10C12.3431 10 11 11.3431 11 13V21C11 22.6569 12.3431 24 14 24H22C23.6569 24 25 22.6569 25 21V13C25 11.3431 23.6569 10 22 10H14ZM13 13C13 12.4477 13.4477 12 14 12H22C22.5523 12 23 12.4477 23 13V21C23 21.5523 22.5523 22 22 22H14C13.4477 22 13 21.5523 13 21V13Z"
                  fill="#777E91"
                  transform="translate(-1 0)"
                />
                <path
                  d="M16 14C15.4477 14 15 14.4477 15 15C15 15.5523 15.4477 16 16 16H20C20.5523 16 21 15.5523 21 15C21 14.4477 20.5523 14 20 14H16Z"
                  fill="#777E91"
                />
              </svg>
              Marketplace
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
      )}
      {donationsEnabled && (
        <Nav.Item as="li">
          <LinkContainer to="donations">
            <Nav.Link>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 3C10.8954 3 10 3.89543 10 5V6H8C6.34315 6 5 7.34315 5 9V19C5 20.6569 6.34315 22 8 22H16C17.6569 22 19 20.6569 19 19V9C19 7.34315 17.6569 6 16 6H14V5C14 3.89543 13.1046 3 12 3ZM12 7C13.1046 7 14 7.89543 14 9V10H10V9C10 7.89543 10.8954 7 12 7ZM8 9H16V19H8V9Z"
                  fill="#777E91"
                />
                <path
                  d="M12 11C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V12C13 11.4477 12.5523 11 12 11Z"
                  fill="#777E91"
                />
              </svg>
              Donations
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
      )}
    </Stack>
  )
}
